import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ComponentRef,
  Injector,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { NzTableModule } from 'ng-zorro-antd/table';
import {
  DataItem,
  InsightData,
} from '../../../insights-data/insights-data.interface';
import { ManageStudentDrawerParams } from '../../../../insights.interface';
import { CommonModule } from '@angular/common';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { CommonService } from '../../../../../../shared/services/common.service';
import { LoaderService } from '../../../../../../core/services/loader.service';
import { InsightsDataService } from '../../../insights-data/insights-data.service';
import { finalize, Observable, of, Subject, take, takeUntil } from 'rxjs';
import { ErrorResponse } from '../../../../../../core/models/error.models';
import { ConfirmDialogComponent } from '../../../../../../components/confirm-dialog/confirm-dialog.component';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { DataGraphComponent } from '../../../insights-data/data-graph/data-graph.component';
import { EnterDataComponent } from '../../../insights-data/enter-data/enter-data.component';
import { DRAWER_IDS } from '../../../../../../core/constants/drawer-ids.constant';
import { DrawerService } from '../../../../../../core/services/drawer.service';
import { PrintDatasheetComponent } from '../../../insights-data/print-datasheet/print-datasheet.component';
import { OrgScheduleList } from '../../../../../manage-settings/manage-settings.interface';
import { OrganizationModel } from '../../../../../organizations/organization.interface';
import { CustomTimeService } from '../../../../../manage-settings/custom-time/custom-time.service';
import { OrganizationService } from '../../../../../organizations/organization.service';
import { instructionData } from '../../../insights-data/datasheet-instruction';
import { DrawerHeaderComponent } from '../../../../../../components/drawer-header/drawer-header.component';
@Component({
  selector: 'app-data-sheet',
  standalone: true,
  imports: [
    NzTableModule,
    CommonModule,
    NzButtonModule,
    NzSpinModule,
    ConfirmDialogComponent,
    DrawerHeaderComponent,
  ],
  templateUrl: './data-sheet.component.html',
  styleUrl: './data-sheet.component.scss',
})
export class DataSheetComponent implements OnInit, OnDestroy, OnChanges {
  @Input() caseParams: ManageStudentDrawerParams | null = null;
  @Input() behaviorId: number | null = null;
  @ViewChild('drawerTitleEnterData')
  drawerTitleEnterData!: TemplateRef<void>;
  @ViewChild('drawerTitleDataGraph')
  drawerTitleDataGraph!: TemplateRef<void>;
  showConfirmDialog = false;
  isDeleting = false;
  loading$: Observable<boolean> = of(false);
  private readonly destroy$ = new Subject<void>();
  insightsData: InsightData = {} as InsightData;
  selectedUnit = 0;
  constructor(
    private readonly commonService: CommonService,
    private readonly loaderService: LoaderService,
    private readonly insightsService: InsightsDataService,
    private readonly cdr: ChangeDetectorRef,
    private readonly drawerService: DrawerService,
    private readonly customTimeService: CustomTimeService,
    private readonly orgService: OrganizationService,
    private readonly injector: Injector,
    private readonly viewContainerRef: ViewContainerRef
  ) {
    this.loading$ = this.loaderService.loading$;
  }

  listOfData: DataItem[] = [
    {
      name: 'Frequency/Duration Based Datasheet',
      action: '',
      isEnabled: true,
      isPrintLoading: false,
    },
    { name: 'Latency', action: '', isEnabled: false, isPrintLoading: false },
    {
      name: 'Partial Interval',
      action: '',
      isEnabled: false,
      isPrintLoading: false,
    },
    {
      name: 'Replacement Behavior',
      action: '',
      isEnabled: false,
      isPrintLoading: false,
    },
  ];
  originalListOfData = [...this.listOfData];

  ngOnInit(): void {
    this.originalListOfData = [...this.listOfData];
    this.getInsightsData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['behaviorId']) {
      this.getInsightsData();
    }
  }

  private getInsightsData() {
    if (this.behaviorId) {
      this.loaderService.show();
      this.insightsService
        .getInsightData(this.behaviorId)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: response => {
            if (response.result) {
              this.insightsData = response.result;
            }

            this.loaderService.hide();
            const orginalList = [...this.originalListOfData];
            this.cdr.detectChanges();
            orginalList[0].isEnabled =
              this.insightsData.frequencyBasedDatasheet;
            orginalList[2].isEnabled = this.insightsData.partialInterval;
            orginalList[1].isEnabled = this.insightsData.latency;
            if (this.insightsData.isReplacementStratageyApplied) {
              orginalList[3].isEnabled = this.insightsData.replacementBehavior;
              this.listOfData = orginalList;
            } else {
              this.listOfData = orginalList.filter((_, index) => index !== 3);
              this.cdr.detectChanges();
            }
            this.cdr.detectChanges();
          },
          error: error => {
            this.loaderService.hide();
            this.commonService.notify('error', error.message);
          },
        });
    }
  }

  enableDataSheet(unitNo: number) {
    if (this.caseParams?.caseBehaviorId) {
      this.loaderService.show();
      const operation$ = this.insightsService.enableDatasheet({
        caseBehaviorId: this.caseParams.caseBehaviorId,
        unitName: unitNo,
      });
      operation$
        .pipe(
          take(1),
          takeUntil(this.destroy$),
          finalize(() => {
            this.loaderService.hide();
          })
        )
        .subscribe({
          next: () => {
            this.getInsightsData();
          },
          error: error => {
            this.loaderService.hide();
            this.handleError(error);
          },
        });
    }
  }

  removeDatasheet() {
    if (this.caseParams?.caseBehaviorId) {
      this.isDeleting = true;
      const operation$ = this.insightsService.removeDatasheet({
        caseBehaviorId: this.caseParams.caseBehaviorId,
        unitName: this.selectedUnit,
      });
      operation$
        .pipe(
          take(1),
          takeUntil(this.destroy$),
          finalize(() => {
            this.loaderService.hide();
          })
        )
        .subscribe({
          next: () => {
            this.isDeleting = false;
            this.showConfirmDialog = false;
            this.getInsightsData();
            this.commonService.notify(
              'success',
              'Record deleted successfully.'
            );
          },
          error: error => {
            this.isDeleting = false;
            this.showConfirmDialog = false;
            this.handleError(error);
          },
        });
    }
  }
  private handleError({ errors, message }: ErrorResponse): void {
    const errorMessages = errors.map(
      err => err.description || err.detailedMessage
    );
    this.commonService.notify('error', errorMessages, message);
  }

  toggleData(isEnable: boolean, unitNo: number) {
    this.selectedUnit = unitNo;
    if (isEnable) {
      this.showConfirmDialog = true;
    } else {
      this.enableDataSheet(unitNo);
    }
  }
  handleCancel() {
    this.showConfirmDialog = false;
    this.isDeleting = false;
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openEnterDataDrawer(unitNo: number): void {
    this.drawerService.openDrawer(
      EnterDataComponent,
      this.drawerTitleEnterData as unknown as TemplateRef<object>,
      1170,
      true,
      undefined,
      {
        selectedUnit: unitNo,
        caseDetail: this.caseParams?.case,
        behavior: this.caseParams?.behavior,
        caseBehaviorId: this.caseParams?.behavior?.id,
        selectedUnitName: this.listOfData[unitNo - 1].name,
      },
      DRAWER_IDS.ENTER_DATA
    );
  }

  openDataGraphsDrawer(unitNo: number): void {
    this.drawerService.openDrawer(
      DataGraphComponent,
      this.drawerTitleDataGraph as unknown as TemplateRef<object>,
      1170,
      true,
      undefined,
      {
        selectedUnit: unitNo,
        caseDetail: this.caseParams?.case,
        behavior: this.caseParams?.behavior,
        caseBehaviorId: this.caseParams?.behavior?.id,
      },
      DRAWER_IDS.DATA_GRAPH
    );
  }

  getDataSheetInfo() {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    return instructionData.datasheets.find(
      (sheet: any) => sheet.unit === this.selectedUnit
    );
  }
  async printDatasheet(index: number, data: DataItem) {
    this.selectedUnit = index;
    const factory = this.viewContainerRef.createComponent(
      PrintDatasheetComponent,
      {
        injector: this.injector,
      }
    );
    const componentElement = factory.location.nativeElement;
    componentElement.style.display = 'none';
    data.isPrintLoading = true;
    if (this.caseParams?.case?.student?.organizationId) {
      await Promise.all([
        this.commonService.convertImageToBase64('/assets/images/logo.png'),
        this.orgService
          .getOrganization(this.caseParams?.case?.student.organizationId)
          .toPromise(),
        this.customTimeService
          .getOrgSechduleById(this.caseParams?.case?.student.customScheduleId)
          .toPromise(),
      ])
        .then(
          ([res, orgRes, schedules]: [
            string,
            OrganizationModel | undefined,
            OrgScheduleList[] | undefined,
          ]) => {
            factory.instance.dataSheetData = {
              caseDetail: this.caseParams?.case,
              logo: res,
              orgDetail: orgRes,
              behavior: this.caseParams?.behavior,
              datasheetInfo: this.getDataSheetInfo(),
              timeSlots: schedules ? schedules[0].timeSlots : [],
              behaviorNames:
                this.caseParams?.behavior?.behaviorCategoryTypes.map(
                  item => item.behaviorTypeName
                ),
            };
            this.cdr.detectChanges();
            this.waitForInitialization(factory).then(async () => {
              await factory.instance.printPDF();
              factory.destroy();
            });
          }
        )
        .catch(e => console.error(e))
        .finally(() => {
          data.isPrintLoading = false;
          this.cdr.detectChanges();
        });
    }
  }

  waitForInitialization(factory: ComponentRef<PrintDatasheetComponent>) {
    return new Promise<void>(resolve => {
      const interval = setInterval(() => {
        if (factory.instance.initialized) {
          clearInterval(interval);
          resolve();
        }
      }, 10);
    });
  }
}
